<template style="height: 100%;">
  <div class="CommonContentSingle-gray Content_analysis">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item label="时间">
            <el-date-picker v-model="from.DateS" type="datetimerange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>


          <el-form-item label="内容形式">
            <el-select v-model="from.formal" placeholder="请选择内容形式">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="文章" value="文章"></el-option>
              <el-option label="图片" value="图片"></el-option>
              <el-option label="视频" value="视频"></el-option>
              <el-option label="音乐" value="音乐"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="标签">
            <el-select v-model="from.lebel" placeholder="请选择标签">
              <el-option v-for="item in options" :key="item.DropKeyID" :label="item.DropKeyContent"
                :value="item.DropKeyID">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="内容">
            <el-input v-model="from.Content" placeholder="请输入内容"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
          </el-form-item>

        </el-form>
      </el-header>


      <el-main>
        <el-table ref="multipleTable" v-loading="wloadings" :data="tableData" style="width: 100%; margin-top: 10px;">
          <el-table-column label="序号" min-width="20px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="标题">
            <template slot-scope="scope">
              <span>{{ scope.row.MaterialName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容形式">
            <template slot-scope="scope">
              <span>{{ scope.row.MaterialType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间">
            <template slot-scope="scope">
              <span>{{ scope.row.CreatedDate }}</span>
            </template>
          </el-table-column>

          <el-table-column label="阅读量">
            <template slot-scope="scope">
              <span>{{ scope.row.Type1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点赞数">
            <template slot-scope="scope">
              <span>{{ scope.row.Type2 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分享数">
            <template slot-scope="scope">
              <span>{{ scope.row.Type3 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="looks(scope.row)">查看详情</el-button>
              <el-button type="primary" size="mini" @click="qushi(scope.row)">趋势图</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination :current-page.sync="currentPage1" @current-change="handleCurrentChange" :page-size="10"
            layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </el-main>

    </el-container>

    <!-- <div id="myChart" :style="{width: '300px', height: '300px'}"> </div> -->

    <el-dialog title="趋势图" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div id="myChart" :style="{ width: '300px', height: '300px' }"> </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      dialogVisible: true,
      options: [],
      tableData: [],
      currentPage1: 1,
      pageIndexs: 1,
      wloadings: true,
      Counts: 0,
      pageIndex: 1,
      from: {
        DateS: [],
        formal: '全部',
        lebel: '',
        Content: '',
      },
    }
  },

  components: {

  },

  methods: {

    looks() {

    },
    qushi(val) {
      this.dialogVisible = true

      this.$Http_Post('Publicity/MaterialDetailsAnalysis', { "Year": "2020", "Month": "", "MaterialID": val.MaterialID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {

        } else {
          this.wloadings = false;
        }
      },)

      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        title: { text: '在Vue中使用echarts' },
        tooltip: {},
        xAxis: {
          data: ["湖人队", "火箭队", "热火队", "勇士队", "篮网队", "快船队"]
        },
        yAxis: {},
        series: [{
          name: '总比分',
          type: 'bar',
          data: [50, 20, 36, 10, 10, 20]
        }]
      });

    },
    chaxun() {
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    handleCurrentChange(val) {
      // this.pageIndex = val
      // this.loading(this.pageIndex,this.from.Content);
    },
    loading(pageIndex, Content) {
      this.$Http_Post('Publicity/ContentAnalysisList', { "DateS": this.from.DateS, "formal": this.from.formal, "lebel": this.from.lebel, "Content": this.from.Content, "pageSize": "10", "pageIndex": pageIndex, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Counts = Number(res.Counts);
          this.wloadings = false
        } else {
          this.wloadings = false;
        }
      },)
    },
  },
  mounted() {
    // this.drawLine();

    var dataForm = {
      pageSize: 100,
      pageIndex: 0,
      DropKeyType: "MaterialLabe",
    }
    this.$Http_Post('workingtime/getdropdownkeylist', dataForm).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.options = res.Data
      }
    },
    )
    this.loading(1, this.from.Content);
    this.dialogVisible = false
  },
  watch: {
    //监听
  },
}

</script>

<style>
.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>
